import ContentManagementPage from '../../ContentManagement/ContentManagementPage';

const ServiceContentManagementNoParamsPage = () => (
  <ContentManagementPage mode="serviceNoParams" />
);

export default ServiceContentManagementNoParamsPage;
